import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { signInGuard } from './features/authentication/guards/sign-in.guard';
import { forcePasswordChangeGuard } from './features/authentication/guards/force-password-change.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'authentication/sign-in',
    pathMatch: 'full',
  },
  {
    path: 'authentication',
    children: [
      {
        path: 'sign-in',
        canActivate: [signInGuard],
        loadComponent: () =>
          import('./features/authentication/components/sign-in/sign-in.component').then(
            (m) => m.SignInComponent,
          ),
      },
      {
        path: 'sign-out',
        loadComponent: () =>
          import('./features/authentication/components/sign-out/sign-out.component').then(
            (m) => m.SignOutComponent,
          ),
      },
      {
        path: 'sign-up',
        loadComponent: () =>
          import('./features/authentication/components/sign-up/sign-up.component').then(
            (m) => m.SignUpComponent,
          ),
      },
      {
        path: 'sign-up-success',
        loadComponent: () =>
          import('./features/authentication/components/sign-up-success/sign-up-success.component').then(
            (m) => m.SignUpSuccessComponent,
          ),
      },
      {
        path: 'validation-email',
        loadComponent: () =>
          import('./features/authentication/components/validation-email/validation-email.component').then(
            (m) => m.ValidationEmailComponent,
          ),
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./features/authentication/components/forgot-password/forgot-password.component').then(
            (m) => m.ForgotPasswordComponent,
          ),
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('./features/authentication/components/reset-password/reset-password.component').then(
            (m) => m.ResetPasswordComponent,
          ),
      },
      {
        path: 'set-password',
        loadComponent: () =>
          import('./features/authentication/components/set-password-from-email/set-password-from-email.component').then(
            (m) => m.SetPasswordFromEmailComponent,
          ),
      },
      {
        path: 'force-password-change',
        canActivate: [forcePasswordChangeGuard],
        loadComponent: () =>
          import('./features/authentication/components/force-password-change/force-password-change.component').then(
            (m) => m.ForcePasswordChangeComponent,
          ),
      },
      {
        path: '',
        redirectTo: 'sign-in',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'app',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./core/components/general/general.component').then((m) => m.GeneralComponent),
    loadChildren: () =>
      import('./core/components/general/general.routes').then((m) => m.generalRoutes),
  },
];
